import { Avatar } from 'shared/ui'
import { css } from '@emotion/react'
import { indicator } from '@groovehq/internal-design-system/lib/styles/elements'
import styles from './styles.css'

export default function Suggestion({ suggestion }) {
  const suggestObj =
    typeof suggestion === 'string' ? { suggestion } : suggestion
  const { avatar_url: avatarUrl, hint, suggestion: suggestionText } = suggestObj
  if (suggestion) {
    return (
      <div className={styles.SearchSuggestions_suggestion}>
        {avatarUrl && (
          <Avatar
            size={20}
            actor={suggestObj}
            css={css`
              flex-shrink: 0;
            `}
          />
        )}
        <div className={styles.label} css={indicator.styles.accentNeutral}>
          {suggestionText}
        </div>
        {hint && <div className={styles.hint}>{hint}</div>}
        <div className="Icon Icon-keyboard-return" />
      </div>
    )
  }
  return null
}
